import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ReviewsSection = ({ reviews, averageRating, totalReviews }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "#F59E0B" : "#E5E7EB"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('es-CO', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    })?.format(date);
  };

  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-6">
      <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="MessageSquare" size={24} color="var(--color-primary)" />
        Reseñas y Calificaciones
      </h2>
      {/* Rating Summary */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-6 pb-6 border-b border-border">
        <div className="text-center">
          <div className="text-5xl font-bold text-foreground mb-2">{averageRating}</div>
          <div className="flex items-center gap-1 mb-1">
            {renderStars(Math.round(averageRating))}
          </div>
          <p className="text-sm text-muted-foreground">{totalReviews} reseñas</p>
        </div>

        <div className="flex-1 w-full">
          {[5, 4, 3, 2, 1]?.map((stars) => {
            const count = reviews?.filter((r) => r?.rating === stars)?.length;
            const percentage = (count / totalReviews) * 100;

            return (
              <div key={stars} className="flex items-center gap-3 mb-2">
                <span className="text-sm text-foreground w-8">{stars}</span>
                <Icon name="Star" size={14} color="#F59E0B" className="fill-current" />
                <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-accent rounded-full transition-all"
                    style={{ width: `${percentage}%` }}
                  />
                </div>
                <span className="text-sm text-muted-foreground w-12 text-right">{count}</span>
              </div>
            );
          })}
        </div>
      </div>
      {/* Individual Reviews */}
      <div className="space-y-4">
        {reviews?.map((review) => (
          <div key={review?.id} className="border border-border rounded-lg p-4">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
                <Image
                  src={review?.userAvatar}
                  alt={review?.userAvatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <p className="font-semibold text-foreground">{review?.userName}</p>
                  <p className="text-xs text-muted-foreground">{formatDate(review?.date)}</p>
                </div>
                <div className="flex items-center gap-1">
                  {renderStars(review?.rating)}
                </div>
              </div>
            </div>
            <p className="text-foreground leading-relaxed">{review?.comment}</p>
            {review?.helpful > 0 && (
              <div className="flex items-center gap-2 mt-3 text-sm text-muted-foreground">
                <Icon name="ThumbsUp" size={14} />
                <span>{review?.helpful} personas encontraron esto útil</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSection;